import * as i0 from '@angular/core';
import { Injectable, NgModule } from '@angular/core';
import * as i1 from '@upr-web-primer/dal';
import { DalService } from '@upr-web-primer/dal';
import * as i1$1 from '@upr-web-primer/testing';
import { TestingService } from '@upr-web-primer/testing';
import { ReplaySubject, firstValueFrom } from 'rxjs';
class FtcService {
  constructor(dal) {
    this.dal = dal;
  }
  findSubscriptionContract(request, resortCode = 'UOR') {
    const method = 'POST';
    const endpoint = `/resort-areas/${resortCode}/find-subscription-contract`;
    return this.dal.httpRequest(endpoint, method, request);
  }
  cancelSubscriptionContract(request, resortCode = 'UOR') {
    const method = 'POST';
    const endpoint = `/resort-areas/${resortCode}/cancel-subscription-contract`;
    return this.dal.httpRequest(endpoint, method, request, undefined, undefined, undefined, true);
  }
  sendCancellationEmail(request, resortCode = 'UOR') {
    const method = 'POST';
    const endpoint = `/resort-areas/${resortCode}/notify-cancel-subscription`;
    return this.dal.httpRequest(endpoint, method, request);
  }
  static {
    this.ɵfac = function FtcService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FtcService)(i0.ɵɵinject(i1.DalService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FtcService,
      factory: FtcService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FtcService, [{
    type: Injectable
  }], () => [{
    type: i1.DalService
  }], null);
})();
class FtcTestService {
  constructor(testingMode) {
    this.testingMode = testingMode;
    this.mockData$ = new ReplaySubject();
    this.init();
  }
  init() {
    this.getJsonMock();
  }
  async getJsonMock() {
    this.mockData = (await Promise.resolve().then(function () {
      return ftc_test_service_mock;
    })).FTCMockData;
    this.mockData$.next(this.mockData);
  }
  findSubscriptionContract() {
    return firstValueFrom(this.mockData$).then(mockData => {
      const testStatusSessionStorageKey = 'TEST_FTC_FIND_SUBSCRIPTION_CONTRACT';
      return this.testingMode.makeRequest('/resort-areas/UOR/find-subscription-contract', 'POST', testStatusSessionStorageKey, mockData);
    });
  }
  cancelSubscriptionContract() {
    return firstValueFrom(this.mockData$).then(mockData => {
      const testStatusSessionStorageKey = 'TEST_FTC_CANCEL_SUBSCRIPTION_CONTRACT';
      return this.testingMode.makeRequest('/resort-areas/UOR/cancel-subscription-contract', 'POST', testStatusSessionStorageKey, mockData);
    });
  }
  sendCancellationEmail() {
    return firstValueFrom(this.mockData$).then(mockData => {
      const testStatusSessionStorageKey = 'TEST_FTC_SEND_CANCELLATION_EMAIL';
      return this.testingMode.makeRequest('/resort-areas/UOR/notify-cancel-subscription', 'POST', testStatusSessionStorageKey, mockData);
    });
  }
  ngOnDestroy() {
    this.mockData$?.unsubscribe();
  }
  static {
    this.ɵfac = function FtcTestService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FtcTestService)(i0.ɵɵinject(i1$1.TestingService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: FtcTestService,
      factory: FtcTestService.ɵfac
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FtcTestService, [{
    type: Injectable
  }], () => [{
    type: i1$1.TestingService
  }], null);
})();
function FtcDataServiceFactory(dal, testingService) {
  return testingService.isTestMode() ? new FtcTestService(testingService) : new FtcService(dal);
}
class FtcModule {
  static {
    this.ɵfac = function FtcModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || FtcModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: FtcModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: FtcService,
        useFactory: FtcDataServiceFactory,
        deps: [DalService, TestingService]
      }]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FtcModule, [{
    type: NgModule,
    args: [{
      providers: [{
        provide: FtcService,
        useFactory: FtcDataServiceFactory,
        deps: [DalService, TestingService]
      }]
    }]
  }], null, null);
})();
const FTCMockData = {
  '/resort-areas/UOR/find-subscription-contract': {
    POST: {
      '200': {
        email: 'user@example.com',
        contract_id: '67',
        status: 'active',
        auto_renewal: true,
        is_contract_year_one: false,
        expiration_date: '2025-12-31',
        remaining_payments: 5,
        next_payment_date: '2024-06-15',
        payment_contract_renew_date: '2025-01-01',
        linked_passes: [{
          first_name: 'Mary-Lynn',
          last_name: "O'Brian",
          plu: 'PLU1234',
          pass_description: '2-Park 12-Month Power Adult Non-Resident Pass',
          pass_id: '13651454519643869'
        }, {
          first_name: 'Tester2',
          last_name: 'Test',
          plu: 'PLU1234',
          pass_description: '2-Park 12-Month Power Adult Non-Resident Pass',
          pass_id: '13651454519699999'
        }]
      },
      '201': {
        email: 'user@example.com',
        contract_id: '67',
        status: 'active',
        auto_renewal: true,
        is_contract_year_one: false,
        expiration_date: '2025-12-31',
        remaining_payments: 0,
        next_payment_date: '2024-06-15',
        payment_contract_renew_date: '2025-01-01',
        linked_passes: [{
          first_name: 'Mary-Lynn',
          last_name: "O'Brian",
          plu: 'PLU1234',
          pass_description: '2-Park 12-Month Power Adult Non-Resident Pass',
          pass_id: '13651454519643869'
        }]
      },
      '204': {
        email: 'user@example.com',
        contract_id: '67',
        status: 'canceled',
        auto_renewal: true,
        is_contract_year_one: false,
        expiration_date: '2025-12-31',
        remaining_payments: 0,
        next_payment_date: '2024-06-15',
        payment_contract_renew_date: '2025-01-01',
        linked_passes: [{
          first_name: 'Mary-Lynn',
          last_name: "O'Brian",
          plu: 'PLU1234',
          pass_description: '2-Park 12-Month Power Adult Non-Resident Pass',
          pass_id: '13651454519643869'
        }]
      },
      '404': {
        detail: 'Invalid user input',
        instance: 'string',
        invalid_parms: [{
          field: 'string',
          rule: 'string',
          rule_code: ['string']
        }],
        problem: 'validation-error',
        title: 'Your request parameters did not validate',
        type: 'https://services.use.ucdp.net/carts/validation-error'
      },
      '500': {
        error: 'Internal Server Error'
      }
    }
  },
  '/resort-areas/USH/find-subscription-contract': {
    POST: {
      '200': {
        email: 'user@example.com',
        contract_id: '67',
        status: 'active',
        auto_renewal: true,
        is_contract_year_one: false,
        expiration_date: '2025-12-31',
        remaining_payments: 5,
        next_payment_date: '2024-06-15',
        payment_contract_renew_date: '2025-01-01',
        linked_passes: [{
          first_name: 'Mary-Lynn',
          last_name: "O'Brian",
          plu: 'PLU1234',
          pass_description: '2-Park 12-Month Power Adult Non-Resident Pass',
          pass_id: '13651454519643869'
        }, {
          first_name: 'Tester2',
          last_name: 'Test',
          plu: 'PLU1234',
          pass_description: '2-Park 12-Month Power Adult Non-Resident Pass',
          pass_id: '13651454519699999'
        }]
      },
      '201': {
        email: 'user@example.com',
        contract_id: '67',
        status: 'active',
        auto_renewal: true,
        is_contract_year_one: false,
        expiration_date: '2025-12-31',
        remaining_payments: 0,
        next_payment_date: '2024-06-15',
        payment_contract_renew_date: '2025-01-01',
        linked_passes: [{
          first_name: 'Mary-Lynn',
          last_name: "O'Brian",
          plu: 'PLU1234',
          pass_description: '2-Park 12-Month Power Adult Non-Resident Pass',
          pass_id: '13651454519643869'
        }]
      },
      '204': {
        email: 'user@example.com',
        contract_id: '67',
        status: 'canceled',
        auto_renewal: true,
        is_contract_year_one: false,
        expiration_date: '2025-12-31',
        remaining_payments: 0,
        next_payment_date: '2024-06-15',
        payment_contract_renew_date: '2025-01-01',
        linked_passes: [{
          first_name: 'Mary-Lynn',
          last_name: "O'Brian",
          plu: 'PLU1234',
          pass_description: '2-Park 12-Month Power Adult Non-Resident Pass',
          pass_id: '13651454519643869'
        }]
      },
      '404': {
        detail: 'Invalid user input',
        instance: 'string',
        invalid_parms: [{
          field: 'string',
          rule: 'string',
          rule_code: ['string']
        }],
        problem: 'validation-error',
        title: 'Your request parameters did not validate',
        type: 'https://services.use.ucdp.net/carts/validation-error'
      },
      '500': {
        error: 'Internal Server Error'
      }
    }
  },
  '/resort-areas/UOR/cancel-subscription-contract': {
    POST: {
      '200': {
        order_confirmation_number: 'U04563598',
        first_name: 'Mary-Lynn',
        last_name: "O'Brian",
        last_four: 1234,
        contract_id: 'CONTRACT12345',
        status: 'canceled',
        auto_renew_status: 'disabled',
        pass_expiration_updated: true,
        restore_subscription_at: '2025-01-15T12:00:00Z'
      },
      '404': {
        detail: 'Invalid user input',
        instance: 'string',
        invalid_parms: [{
          field: 'string',
          rule: 'string',
          rule_code: ['string']
        }],
        problem: 'validation-error',
        title: 'Your request parameters did not validate',
        type: 'https://services.use.ucdp.net/carts/validation-error'
      },
      '500': {
        error: 'Internal Server Error'
      },
      '400': {
        detail: 'Invalid user input',
        instance: 'string',
        problem: 'validation-error',
        title: 'Your request parameters did not validate',
        type: 'https://services.use.ucdp.net/carts/validation-error'
      }
    }
  },
  '/resort-areas/USH/cancel-subscription-contract': {
    POST: {
      '200': {
        order_confirmation_number: 'U04563598',
        first_name: 'Mary-Lynn',
        last_name: "O'Brian",
        last_four: 1234,
        contract_id: 'CONTRACT12345',
        status: 'canceled',
        auto_renew_status: 'disabled',
        pass_expiration_updated: true,
        restore_subscription_at: '2025-01-15T12:00:00Z'
      },
      '404': {
        detail: 'Invalid user input',
        instance: 'string',
        invalid_parms: [{
          field: 'string',
          rule: 'string',
          rule_code: ['string']
        }],
        problem: 'validation-error',
        title: 'Your request parameters did not validate',
        type: 'https://services.use.ucdp.net/carts/validation-error'
      },
      '500': {
        error: 'Internal Server Error'
      },
      '400': {
        detail: 'Invalid user input',
        instance: 'string',
        problem: 'validation-error',
        title: 'Your request parameters did not validate',
        type: 'https://services.use.ucdp.net/carts/validation-error'
      }
    }
  },
  '/resort-areas/UOR/notify-cancel-subscription': {
    POST: {
      '200': {
        message: 'success'
      },
      '500': {
        error: 'Internal Server Error'
      }
    }
  },
  '/resort-areas/USH/notify-cancel-subscription': {
    POST: {
      '200': {
        message: 'SUCCESS'
      },
      '500': {
        error: 'Internal Server Error'
      }
    }
  }
};
var ftc_test_service_mock = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FTCMockData: FTCMockData
});

/*
 * Public API Surface of ftc
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FTCMockData, FtcDataServiceFactory, FtcModule, FtcService };
